import type {
  ComparisonRow,
  Faq,
  PainPoint,
  Testimonial,
  ValueRow
} from '../types/sales'

export const painPoints: PainPoint[] = [
  {
    emoji: '😶',
    text: 'Estás con alguien que te gusta y literalmente no sabes qué decir. El silencio incómodo lo dice todo.'
  },
  {
    emoji: '😓',
    text: 'Vas a una primera cita y la arruinas por nervios, por hablar de más, o por no saber cómo crear tensión.'
  },
  {
    emoji: '😤',
    text: 'Ves su lenguaje corporal y no sabes si le gustas o si apenas te está tolerando. Adivinas. Siempre adivinas.'
  },
  {
    emoji: '💔',
    text: 'Conoces personas increíbles pero nunca logras pasar del "me cayó bien" al "quiero saber más de ti".'
  },
  {
    emoji: '🤦',
    text: 'Has leído consejos en internet y NINGUNO funciona porque todos son genéricos, teóricos y completamente alejados de la realidad.'
  }
]

export const valueRows: ValueRow[] = [
  { label: 'Seducción Sin Máscaras', value: '$27.00' },
  { label: '30 Historias de Amor Verdadero', value: '$27.00' },
  { label: 'Guía de Primeras Citas que Funcionan', value: '$27.00' },
  { label: 'Más Allá de las Palabras', value: '$27.00' },
  { label: 'El Arte de la Conversación', value: '$27.00' }
]

export const comparisonRows: ComparisonRow[] = [
  { feature: 'Contenido práctico y accionable', courses: true, youtube: false, bundle: true },
  { feature: 'Sin teoría aburrida', courses: false, youtube: false, bundle: true },
  { feature: 'Todo en un solo lugar', courses: false, youtube: false, bundle: true },
  { feature: 'Precio accesible', courses: false, youtube: true, bundle: true },
  { feature: 'Acceso inmediato sin suscripción', courses: false, youtube: true, bundle: true },
  { feature: 'Cubre TODOS los aspectos del amor', courses: false, youtube: false, bundle: true }
]

export const testimonials: Testimonial[] = [
  {
    quote:
      'Leí el de lenguaje corporal en una tarde y esa misma semana noté señales que antes ignoraba completamente. Ahora sé cuándo hay interés real y cuándo no.',
    name: 'Marcos R.',
    age: 32,
    city: 'Guadalajara'
  },
  {
    quote:
      'La guía de primeras citas me cambió la vida. Iba con terror a cada cita. Ahora voy con un plan claro y me la paso bien. Llevo 3 citas geniales este mes.',
    name: 'Sofía L.',
    age: 27,
    city: 'Madrid'
  },
  {
    quote:
      'Honestamente pensé que eran libros más de lo mismo. Me equivoqué. El de conversación es oro puro. Aprendí más en 2 horas que en años viendo videos en YouTube.',
    name: 'Alejandro V.',
    age: 35,
    city: 'Bogotá'
  },
  {
    quote:
      'Las historias de amor son increíbles. Terminé llorando en dos de ellas pero también con una claridad que no tenía. Entendí exactamente por qué mis relaciones anteriores no funcionaron.',
    name: 'Laura M.',
    age: 29,
    city: 'Buenos Aires'
  },
  {
    quote:
      '$9.99 por todo esto es una broma. He pagado más por un café en el aeropuerto. Cada libro vale mínimo lo que dicen que vale.',
    name: 'David P.',
    age: 38,
    city: 'Ciudad de México'
  },
  {
    quote:
      'Seducción Sin Máscaras me hizo darme cuenta de cuánto me esforzaba por ser alguien que no soy. Ahora soy yo mismo y funciona MUCHO mejor. Ojalá lo hubiera leído hace 10 años.',
    name: 'Carlos N.',
    age: 41,
    city: 'Lima'
  },
  {
    quote:
      'Nunca supe qué preguntar sin sonar a entrevista de trabajo. Con las preguntas del volumen 5 la conversación fluyó sola y ella me escribió al día siguiente.',
    name: 'Valentina C.',
    age: 24,
    city: 'Santiago'
  },
  {
    quote:
      'Lo leí en el metro camino al trabajo. En dos semanas dejé de perder tiempo con personas que claramente no estaban interesadas. Eso solo ya valió los $9.99.',
    name: 'Andrés T.',
    age: 30,
    city: 'Medellín'
  },
  {
    quote:
      'Soy tímida y pensé que nada de esto me iba a servir. El checklist de pre-cita me quitó los nervios de encima. Fui tranquila por primera vez en mi vida.',
    name: 'Paula G.',
    age: 26,
    city: 'Monterrey'
  },
  {
    quote:
      'Después de un divorcio no sabía ni cómo empezar de nuevo. Estos libros me dieron un punto de partida claro y sin sentirme patético.',
    name: 'Ricardo H.',
    age: 44,
    city: 'Quito'
  },
  {
    quote:
      'Lo de las micro-expresiones me pareció exagerado hasta que lo probé. Detecté incomodidad en una cita y cambié de tema. Terminamos hablando cuatro horas.',
    name: 'Natalia B.',
    age: 33,
    city: 'Barcelona'
  },
  {
    quote:
      'Cinco libros por menos de lo que cuesta un cóctel. Los leí todos en un fin de semana y volví al de conversación tres veces. Es el que más uso.',
    name: 'Emilio S.',
    age: 28,
    city: 'San José'
  },
  {
    quote:
      'Lo compré con dudas y lo descargué en segundos. Nada de esperar, nada de suscripciones raras. Y el contenido es mucho mejor de lo que esperaba por el precio.',
    name: 'Camila F.',
    age: 31,
    city: 'Montevideo'
  },
  {
    quote:
      'Lo que más me sirvió fue entender que no tenía que fingir seguridad. El cambio se notó en cómo me trata la gente, no solo en las citas.',
    name: 'Julián P.',
    age: 36,
    city: 'Asunción'
  }
]

export const faqs: Faq[] = [
  {
    question: '¿Estos libros son para hombres o para mujeres?',
    answer:
      'Para ambos. El contenido aplica igualmente sin importar tu género. Ya sea que busques atraer, conectar o entender mejor las relaciones, cada libro tiene valor directo para ti.'
  },
  {
    question: '¿Qué pasa si ya sé bastante de este tema?',
    answer:
      'Lo que encontrarás aquí no es la teoría que ya leíste en blogs. Es contenido práctico, directo y accionable. Si ya sabes del tema, estos libros te van a dar la estructura que te faltaba para que ese conocimiento funcione de verdad.'
  },
  {
    question: '¿Cuándo recibo los libros?',
    answer:
      'Inmediatamente después de tu compra. Recibes acceso y descarga al instante. No tienes que esperar nada.'
  },
  {
    question: '¿Esto es una suscripción?',
    answer:
      'No. Es un pago único de $9.99. Los libros son tuyos para siempre. Sin cargos futuros, sin sorpresas, sin letra pequeña.'
  },
  {
    question: '¿Por qué están tan baratos si valen $137?',
    answer:
      'Es precio de lanzamiento. El objetivo es que la mayor cantidad de personas pueda acceder a este contenido. Cuando se agoten las copias a este precio, sube. No habrá segunda oportunidad a este valor.'
  },
  {
    question: '¿Funciona si nunca he tenido pareja?',
    answer:
      'Especialmente si nunca has tenido pareja. Estos libros te dan las bases que nadie te enseñó. No necesitas experiencia previa. Necesitas exactamente lo que estos libros contienen.'
  }
]
